<div id="{{ content.key }}" class="row">
	<div class="col-12 text-center">
		<a href="{{ content.attributes.video }}" class="embedly-card">Embedly</a>
	</div>
	<div class="col-12 text-center" *ngIf="content.attributes.caption">{{ content.attributes.caption }}</div>
</div>
